<template>
    <div v-if="!loadingPage" class="pb-1">
        <b-row>
            <b-col lg="3" md="4" class="mt-25">
                <b-form-group label-for="storeOrderNumberId" label="شماره فاکتور">
                    <b-form-input @keyup.enter="orderDetailsStoreOrderNumber" v-model="storeOrderNumber"
                        inputmode="numeric" id="storeOrderNumberId" dir="ltr" type="number" autocomplete="off"
                        class="text-center" name="storeOrderNumberId" />
                </b-form-group>
            </b-col>
            <b-col lg="3" md="4" class="mt-25">
                <b-form-group label-for="dailyOrderNumberId" label="شماره سفارش">
                    <b-form-input @keyup.enter="orderDetailsStoreOrderNumber" v-model="dailyOrderNumber"
                        inputmode="numeric" id="dailyOrderNumberId" dir="ltr" type="number" autocomplete="off"
                        class="text-center" name="dailyOrderNumberId" />
                </b-form-group>
            </b-col>
            <b-col lg="2" md="3" class="mt-md-2 mt-50">
                <b-button @click="orderDetailsStoreOrderNumber" variant="info"
                    class="w-100 d-flex align-items-center justify-content-center mt-md-25 mt-0" :disabled="loading">
                    <b-spinner v-if="loading" class="mr-50" variant="white" small></b-spinner>
                    <span>جستجو</span>
                </b-button>
            </b-col>
            <b-col lg="2" md="3" class="mt-md-2 mt-1">
                <b-button @click="customersFind" variant="info"
                    class="w-100 d-flex align-items-center justify-content-center mt-md-25 mt-0"
                    :disabled="loading || !customerPhoneNumber">
                    <b-spinner v-if="loading" class="mr-50" variant="white" small></b-spinner>
                    <span>اطلاعات باشگاه مشتری</span>
                </b-button>
            </b-col>
            <b-col v-if="certificateId || certificateId == 0" lg="2" md="3" class="mt-md-2 mt-1">
                <b-button @click="$refs.Printer.printCustomerInvoice()" :disabled="!orderDetails"
                    class="w-100 mt-md-25 mt-0" variant="primary">
                    پرینت فاکتور
                </b-button>
            </b-col>
        </b-row>
        <b-card v-if="customer" class="mt-md-1 mt-2">
            <div>
                <h4 class="mb-0 text-info font-weight-bolder">اطلاعات باشگاه مشتری</h4>
                <b-row>
                    <b-col md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">نام مشتری</h5>
                                <h4 v-if="customer.firstName || customer.lastName" class="mb-0">
                                    {{ customer.firstName }} {{ customer.lastName }}
                                </h4>
                                <h4 v-else class="mb-0">مشتری مجموعه</h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-info">
                                        <feather-icon size="20" icon="UserIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="customer.favoriteProduct" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">محصول مورد علاقه</h5>
                                <h4 class="mb-0">{{ customer.favoriteProduct.name_Fa }}
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="CoffeeIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="customer.group" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">وفاداری</h5>
                                <h4 class="mb-0">{{ customer.group.name }}
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="UsersIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="customer.loyaltyInfo" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">سطح</h5>
                                <h4 class="mb-0">
                                    {{ `${customer.loyaltyInfo.loyaltyLevel.name} /
                                    ${customer.loyaltyInfo.loyaltyLevel.number}` }}
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="TrendingUpIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="customer.loyaltyInfo" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">اعتبار</h5>
                                <div class="d-flex align-items-center">
                                    <h4 class="mb-0">
                                        {{ customer.loyaltyInfo.walletBalance ?
                                            customer.loyaltyInfo.walletBalance.toLocaleString('fa-IR')
                                            : 0 }}
                                    </h4>
                                    <h6 v-if="customer.loyaltyInfo.walletBalance" class="mb-0 ml-25">ریال</h6>
                                </div>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="CreditCardIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                    <b-col v-if="customer.loyaltyInfo" md="6" class="mt-2">
                        <div class="d-flex align-items-center justify-content-between">
                            <div>
                                <h5 class="text-secondary">امتیاز</h5>
                                <h4 class="mb-0">{{ customer.loyaltyInfo.score.toLocaleString('fa-IR') }}
                                </h4>
                            </div>
                            <b-media no-body>
                                <b-media-aside class="mr-0">
                                    <b-avatar rounded size="48" variant="light-secondary">
                                        <feather-icon size="20" icon="StarIcon" />
                                    </b-avatar>
                                </b-media-aside>
                            </b-media>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </b-card>


        <invoiceDetail :orderDetails="orderDetails" />


        <div v-if="certificateId || certificateId == 0">
            <Printer ref="Printer" :customerInvoice="orderPrint" :provider="provider" />
        </div>

    </div>
</template>

<script>
import { BCard, BCardText, BCardBody, BButton, BRow, BCol, BTable, BBadge, BFormInput, BFormGroup, BSpinner, BImg, BAvatar, BMediaAside, BMedia } from 'bootstrap-vue';
import { storeService } from '@core/services';
import Printer from '@/@core/components/printer/index.vue';
import invoiceDetail from '@/@core/components/invoice-detail/index.vue';

export default {
    components: {
        Printer,
        BImg,
        BCard,
        BCardText,
        BButton,
        BCardBody,
        BRow,
        BCol,
        BTable,
        BSpinner,
        BFormInput,
        BFormGroup,
        BBadge,
        invoiceDetail,
        BAvatar,
        BMediaAside,
        BMedia
    },
    data() {
        return {
            certificateId: null,
            loading: false,
            loadingPage: true,
            orderDetails: null,
            customerPhoneNumber: null,
            customer: null,
            storeId: null,
            storeOrderNumber: null,
            dailyOrderNumber: null,
            urlName: null,
            provider: {},
            orderPrint: {}
        }
    },
    methods: {
        customersFind() {
            this.loading = true
            storeService.customersFind(this.storeId, this.customerPhoneNumber).then(({ data }) => {
                this.customer = data.customer
                this.loading = false
            })
                .catch(() => {
                    this.loading = false
                });
        },
        orderDetailsStoreOrderNumber() {
            this.loading = true
            this.orderPrint = {}
            if (this.dailyOrderNumber && this.storeOrderNumber) {
                this.dailyOrderNumber = null
            }
            storeService.orderDetailsStoreOrderNumber(this.storeId, { storeOrderNumber: this.storeOrderNumber, dailyOrderNumber: this.dailyOrderNumber }).then(({ data }) => {
                if (data.isExists) {
                    this.orderDetails = data.order
                    let dataOrder = data.order
                    if (data.order.customer) {
                        this.customerPhoneNumber = data.order.customer.phoneNumber
                        this.orderPrint.firstName = data.order.customer.firstName
                        this.orderPrint.lastName = data.order.customer.lastName
                        this.orderPrint.phoneNumber = data.order.customer.phoneNumber
                    }
                    else {
                        this.customerPhoneNumber = null
                    }
                    this.orderPrint.storeOrderNumber = data.order.storeOrderNumber
                    this.orderPrint.dailyOrderNumber = data.order.dailyOrderNumber
                    this.orderPrint.createdAt = data.order.createdAt
                    this.orderPrint.taxAmount = data.order.taxAmount
                    data.order.campaign ? this.orderPrint.campaignDiscountAmount = data.order.campaign.discountAmount : null
                    this.orderPrint.productDiscountAmount = data.order.productDiscountAmount
                    this.orderPrint.urlName = this.urlName
                    this.orderPrint.discountAmount = data.order.discountAmount
                    this.orderPrint.usedWalletAmount = data.order.usedWalletAmount
                    this.orderPrint.orderAmount = data.order.totalAmount
                    this.orderPrint.amountPayable = data.order.payableAmount
                    this.orderPrint.courierFee = data.order.courierFee
                    this.orderPrint.address = null
                    this.orderPrint.type = data.order.type
                    if (data.order.type == 1) {
                        this.orderPrint.address = data.order.address
                    }
                    this.orderPrint.items = []
                    if (dataOrder.items.length) {
                        dataOrder.items.forEach((obj, index) => {
                            this.orderPrint.items[index] = {};
                            this.orderPrint.items[index].name_Fa = obj.productName
                            this.orderPrint.items[index].number = obj.count
                            this.orderPrint.items[index].finalPrice = obj.finalPrice
                        });
                    }
                    this.$bvModal.show('show-order-list')
                }
                else {
                    this.orderDetails = null
                    this.customerPhoneNumber = null
                    this.$notif({ type: 'normal', title: 'فاکتور با این شماره یافت نشد' });
                }
                this.customer = null
                this.loading = false
                this.storeOrderNumber = null
                this.dailyOrderNumber = null
            })

                .catch((err) => {
                    this.loading = false
                });
        },
        async getStoreDetails() {
            storeService.getInfo(this.storeId).then(({ data }) => {
                data.name_Fa ? this.provider.name = data.name_Fa : this.provider.name = data.name_En;
                this.urlName = data.name_En
                this.provider.logo = data.logoImage;
                this.loadingPage = false
            })
        },
    },
    mounted() {
        this.certificateId = localStorage.getItem("certificateId");
        this.storeId = localStorage.getItem("storeId")
        this.getStoreDetails()
    },
};
</script>